import { defineQuery } from 'next-sanity';

export const getVideoSetting = defineQuery(`
  *[_type == "videoSetting"][0]{
  header,
  title,
  metaDescription,
  CSS, JS,
    featuredVideos[]{
      videoTitle,
      featuredVideo->{
          _id,
          thumbnail {
            ...,
            "imgAsset": asset-> {
              ...,
            }
          },
          slug
        }
    }
  }
`);

export const getVideos = defineQuery(`
  *[_type == 'video' && !(_id in $excludeIds) && category->status == true] | order(coalesce(editedDate, _updatedAt) desc){
  title,
  slug,
  thumbnail{
    ...,
    "imgAsset": asset-> {
      ...,
    }
  },
  category->{
      title
    }
  }
`);

export const getVideoDetails = defineQuery(`
  *[_type == "video" && slug.current == $slug][0]{
    _id,
    title,
    metaDescription,
    url,
    category,
    socialShare,
    CSS, JS,
    author->{
      name
    }
  }  
`);

export const getRecentVideo = defineQuery(`
 *[_type == "video" && ($excludeIds == null || !(_id in $excludeIds)) && category._ref == $category ] | order(editedDate desc)[0...3]{
    title,
    slug,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...,
      }
    },
  }
  `);

export const getVideoListSeoData = defineQuery(`
  *[_type == "videoSetting"]{
    title,
    metaDescription,
  }
 `);

export const getVideoDetailSeoData = defineQuery(`
  *[_type == "video" && slug.current == $slug][0]{
  title,
  slug,
  metaDescription,
  thumbnail,
  url
  }
 `);

export const getAllVideosSlugs = defineQuery(`
  *[_type == "video" && defined(slug.current)][].slug.current`);
